export function getEnvVar(key: string): string {
  const value = (import.meta.env as Record<string, string>)[key];
  if (!value) {
    throw new Error(`Missing env variable: ${key}`);
  }
  return value;
}
